<template>
  <div class="box">
    <!-- <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2>
    <h2>Edit Page</h2> -->
    <BackTop />
  </div>
</template>

<script>
import BackTop from '@/components/BackTop.vue'
export default {
  name: 'ProductEdit',
  components: { BackTop }
}
</script>

<style scoped type="text/less" lang="less">
.box {
  text-align: center;
}
</style>
